<template>
<div class="chapter">
<div class="inner_page">
<p class="half"><a id="page_1"></a>VIRGIN TRAINS</p>
<p class="half1">A PICTORIAL TRIBUTE</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_Halftitle.vue?14f234be